module.exports = __webpack_public_path__ + "static/media/YM47_3.d2a5afac.jpg";